import { useProductFreePushupsInfoQuery, useUserFreePushupsInfoQuery } from './gql/graphql.v3.generated';
import { useUseFreePushupOnProductMutation } from './gql/graphql.v5.generated';

export const useFreePushups = (productId?: number | null) => {
  const {
    data: userFreePushupsInfoData,
    loading: userFreePushupsInfoLoading,
  } = useUserFreePushupsInfoQuery({
    context: {
      batch: true,
      ignoreAuthError: true,
    },
  });
  const {
    data: productFreePushupsInfoData,
    loading: productFreePushupsInfoLoading,
  } = useProductFreePushupsInfoQuery({
    variables: {
      productId: productId as number,
    },
    context: {
      batch: true,
    },
    skip: !productId,
  });

  const [
    useFreePushupOnProduct,
    { loading: useFreePushupOnProductLoading },
  ] = useUseFreePushupOnProductMutation({
    context: { v5: true },
    update: (cache, { data }, options) => {
      if (data?.useFreePushupOnProduct.errors?.length) {
        return;
      }

      cache.modify({
        id: `User:${userFreePushupsInfoData?.viewer.id}`,
        fields: {
          freePushupsLeft: () => Number(data?.useFreePushupOnProduct.freePushupsLeft),
        },
      });

      cache.modify({
        id: `ProductDetails:${options.variables?.productId}`,
        fields: {
          freePushupAvailable: () => false,
          nextFreePushupAt: () => (
            data?.useFreePushupOnProduct.nextFreePushupAt as string
            || productFreePushupsInfoData?.productDetails.nextFreePushupAt
            || ''
          ),
        },
      });

      cache.modify({
        id: `Product:${options.variables?.productId}`,
        fields: {
          freePushupAvailable: () => false,
          nextFreePushupAt: () => (
            data?.useFreePushupOnProduct.nextFreePushupAt as string
            || productFreePushupsInfoData?.productDetails.nextFreePushupAt
            || ''
          ),
        },
      });
    },
  });

  return {
    userFreePushupsInfoLoading,
    productFreePushupsInfoLoading,
    useFreePushupOnProductLoading,
    canUseFreePush: userFreePushupsInfoData?.viewer.canUseFreePush,
    freePushupsLeft: userFreePushupsInfoData?.viewer.freePushupsLeft,
    freePushupsLimit: userFreePushupsInfoData?.viewer.freePushupsLimit,
    freePushupAvailable: productFreePushupsInfoData?.productDetails.freePushupAvailable,
    nextFreePushupAt: productFreePushupsInfoData?.productDetails.nextFreePushupAt,
    handleUseFreePushupOnProduct: useFreePushupOnProduct,
  };
};
